import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletQrisTrxStatusCollectionResponse } from '../../../data/repository/fs-wallet-qris/http-fs-wallet-qris.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletQrisRepository } from '../../repository/fs-wallet-qris.repository';
import { QrisTrxStatusDTO } from './interface/qris-trx-status.dto';

@Injectable({
  providedIn: 'root',
})
export class GetTrxStatusUsecase
  implements
    UseCase<QrisTrxStatusDTO, HttpWalletQrisTrxStatusCollectionResponse>
{
  constructor(private readonly repository: FSWalletQrisRepository) {}

  execute(
    data: QrisTrxStatusDTO
  ): Observable<HttpWalletQrisTrxStatusCollectionResponse> {
    return this.repository.GetTrxStatus(data);
  }
}
